const requestHeaders = () => ({
    'Content-Type': 'application/json; charset=UTF-8',
    'Authorization': sessionStorage.getItem('agronetToken'),
    'Local': localStorage.getItem('lang') || 'en'
});

const sensorGroupsPending = () => ({type: 'SENSOR_GROUPS_PENDING'});
const sensorGroupsError = error => ({type: 'SENSOR_GROUPS_ERROR', error});
const sensorGroupsSuccess = groups => ({type: 'GET_SENSOR_GROUPS_SUCCESS', groups});

const parseResponse = async response => {
    if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    return response.status === 204 ? null : response.json();
};

export const getSensorGroups = () => dispatch => {
    dispatch(sensorGroupsPending());

    return fetch(`${process.env.REACT_APP_API_URL}/sensor-groups`, {
        headers: requestHeaders()
    })
        .then(parseResponse)
        .then(groups => {
            dispatch(sensorGroupsSuccess(groups));
            return groups;
        })
        .catch(error => {
            dispatch(sensorGroupsError(error.message));
            throw error;
        });
};

export const createSensorGroup = request => dispatch => {
    dispatch(sensorGroupsPending());

    return fetch(`${process.env.REACT_APP_API_URL}/sensor-groups/create`, {
        method: 'POST',
        headers: requestHeaders(),
        body: JSON.stringify(request)
    })
        .then(parseResponse)
        .then(group => {
            dispatch({type: 'CREATE_SENSOR_GROUP_SUCCESS', group});
            return group;
        })
        .catch(error => {
            dispatch(sensorGroupsError(error.message));
            throw error;
        });
};

export const updateSensorGroup = (groupId, request) => dispatch => {
    dispatch(sensorGroupsPending());

    return fetch(`${process.env.REACT_APP_API_URL}/sensor-groups/update/${groupId}`, {
        method: 'PUT',
        headers: requestHeaders(),
        body: JSON.stringify(request)
    })
        .then(parseResponse)
        .then(group => {
            dispatch({type: 'UPDATE_SENSOR_GROUP_SUCCESS', group});
            return group;
        })
        .catch(error => {
            dispatch(sensorGroupsError(error.message));
            throw error;
        });
};

export const deleteSensorGroup = groupId => dispatch => {
    dispatch(sensorGroupsPending());

    return fetch(`${process.env.REACT_APP_API_URL}/sensor-groups/delete/${groupId}`, {
        method: 'DELETE',
        headers: requestHeaders()
    })
        .then(parseResponse)
        .then(() => {
            dispatch({type: 'DELETE_SENSOR_GROUP_SUCCESS', groupId});
        })
        .catch(error => {
            dispatch(sensorGroupsError(error.message));
            throw error;
        });
};
